export class DietaryChoiceDTO {
  id!: number;
  question: string = "";
  description: string | null = null;
  options: string[] = [""];
}